export enum LoginResponse {
    LOGIN_SUCCESS, // User logged in or was already logged in
    LOGOUT_SUCCESS, // User logged out or was already logged out
    LOGIN_ERROR, // User or password incorrect
    SERVER_ERROR, // Server returned an error or didn't respond
}